// Az org-structure oldal nézet-váltó fülei (Részlegek / Csapatok / Beosztások) — a KÖZÖS underline-Tabs
// primitívre épül (az assets „Leltár/Igénylések" mintája). A fülek sorrendje a szervezeti fa LEFELÉ haladó
// sorrendje: részleg → csapat → beosztás. Az aktív fül + a váltás a `?tab=` URL-search-paramból jön (a panel
// adja `value` + `onValueChange` propként) → megosztható/visszaállítható link. Három helyről használjuk
// (mindhárom panel a saját toolbar-sávjában rendereli), ezért külön (feature-)komponens.
import { BriefcaseIcon, RectangleGroupIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export type OrgTab = 'departments' | 'teams' | 'positions';

export function OrgStructureTabs({
  value,
  onValueChange,
}: {
  value: OrgTab;
  onValueChange: (value: string) => void;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <Tabs value={value} onValueChange={onValueChange}>
      <TabsList>
        <TabsTrigger value="departments">
          <RectangleGroupIcon />
          {t('orgStructure.tabs.departments')}
        </TabsTrigger>
        <TabsTrigger value="teams">
          <UserGroupIcon />
          {t('orgStructure.tabs.teams')}
        </TabsTrigger>
        <TabsTrigger value="positions">
          <BriefcaseIcon />
          {t('orgStructure.tabs.positions')}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
